export function dec2hex(dec) {
    return dec < 10 ? '0' + String(dec) : dec.toString(16);
}

// generateId :: Integer -> String
export default function uuid(len) {
    let arr = new Uint8Array((len || 40) / 2);
    window.crypto.getRandomValues(arr);
    return Array.from(arr, dec2hex).join('');
}
